import React from 'react';
import type { Achievement } from '@/lib/mockData';
import type { Language } from '@/lib/i18n';
import { t } from '@/lib/i18n';

interface Props {
  achievements: Achievement[];
  language: Language;
}

export default function AchievementsStrip({ achievements, language }: Props) {
  return (
    <div className="bg-card rounded-2xl border border-border card-shadow p-5">
      <h2 className="text-base font-600 text-foreground mb-4">
        {t(language, 'dash_achievements')}
      </h2>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {achievements.slice(0, 8).map((ach) => (
          <div
            key={`ach-${ach.id}`}
            className={`flex flex-col items-center text-center p-3 rounded-xl border transition-all duration-150 ${
              ach.isUnlocked
                ? 'bg-primary/5 border-primary/20' :'bg-muted/40 border-border opacity-50 grayscale'
            }`}
          >
            <span className="text-2xl mb-1.5">{ach.icon}</span>
            <p className="text-xs font-600 text-foreground leading-tight">{ach.title[language]}</p>
            <p className="text-xs text-muted-foreground mt-0.5">+{ach.xpReward} XP</p>
            {ach.isUnlocked && ach.unlockedAt && (
              <span className="mt-1 text-xs text-success font-500">✓</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}